import { EPaginationActionTypes } from '../../actions/pagination';
import { EPromosActionTypes } from '../../actions/promos';
import { mapSearchPromos } from '../../mappers';
import { TReduxActions } from '../../types/redux';
import { IPromosState } from '../../types/redux/promos';

const defaultState: IPromosState = {
  allIds: [],
  previewById: {},
  detailsById: {},
};

export function promosReducer(state: IPromosState = defaultState, action: TReduxActions) {
  if (action.type === EPromosActionTypes.Success) {
    return mapSearchPromos(action.payload);
  }

  if (action.type === EPaginationActionTypes.Success) {
    const { allIds, previewById, detailsById } = mapSearchPromos(action.payload);

    return {
      ...state,
      allIds: [...state.allIds, ...allIds],
      previewById: Object.assign({}, state.previewById, previewById),
      detailsById: Object.assign({}, state.detailsById, detailsById),
    };
  }

  return state;
}
